import React from 'react';

import {
  CardSize,
  IconSlot,
  Main,
  StyledCard,
  StyledCardButton,
  StyledCardLink,
  Title,
  Trailing,
} from './styles';

export type CardProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> & {
  title: React.ReactNode;
  icon?: React.ReactNode;
  trailing?: React.ReactNode;
  size?: CardSize;
  active?: boolean;
  href?: string;
  color?: string;
  backgroundColor?: string;
  borderColor?: string;
  activeBorderColor?: string;
  onClick?: () => void;
};

const Card = ({
  title,
  icon,
  trailing,
  size = 'md',
  active = false,
  href,
  color,
  backgroundColor,
  borderColor,
  activeBorderColor,
  onClick,
  children,
  className,
  style,
  id,
}: CardProps): JSX.Element => {
  const sharedProps = {
    $size: size,
    $active: active,
    $clickable: Boolean(href || onClick),
    $color: color,
    $backgroundColor: backgroundColor,
    $borderColor: borderColor,
    $activeBorderColor: activeBorderColor,
    className,
    style,
    id,
  };

  const content = (
    <>
      <Main>
        {icon && <IconSlot>{icon}</IconSlot>}
        <Title>{title}</Title>
      </Main>
      {trailing && <Trailing>{trailing}</Trailing>}
      {children}
    </>
  );

  if (href) {
    return (
      <StyledCardLink href={href} onClick={onClick} {...sharedProps}>
        {content}
      </StyledCardLink>
    );
  }

  if (onClick) {
    return (
      <StyledCardButton type="button" onClick={onClick} {...sharedProps}>
        {content}
      </StyledCardButton>
    );
  }

  return <StyledCard {...sharedProps}>{content}</StyledCard>;
};

export default Card;
